import React, { useState, useEffect, useRef } from "react";
import { StopFooter } from "./StopFooter";

import { FooterD, Regular, Floor, Button, Bet, Play } from "./FooterStyled";
import { ReactComponent as AutoSvg } from "../../../assets/auto.svg";
import { ReactComponent as FastSvg } from "../../../assets/fast.svg";
// import { ReactComponent as UsdSVG } from "./usd.svg";
import currencies from "../../../lib/currencies/currencies";

// import { MessageFactory } from "../../../lib/messages";
// import { Protocol } from "../../../lib/constants";
import useSound from "use-sound";
import forwardSfx from "../../../audio/goForward.mp3";
import fastplaybtnSound from "../../../audio/fastplaybtn.mp3";
import playSound from "./audio/play.mp3";

import useBetOperations from "../setBet/useBetOperations";

export default function Footer({
  bet,
  betInfo,
  isAutoOn,
  isFast,
  handleIsFast,
  toggleIsAutoOn,
  handleAbove,
  clickable,
  saveBetAndPlay,
  handleBetAmount,
  handleNotification,
  betCount,
  betTotal,
  toFix,
  minBet,
  maxBet,
  currency,
  userSettings,
}) {
  const { sound, volume } = userSettings;
  const [forward] = useSound(forwardSfx, { volume });
  const [playSfx] = useSound(playSound, { volume });
  const [fastplaybtnSfx] = useSound(fastplaybtnSound, { volume });

  const [isTurboOn, setisTurboOn] = useState(false);
  const [clicked, setclicked] = useState(false);
  useEffect(() => {
    setisTurboOn(isFast);
  }, [isFast]);

  const [ubet, , , multiply, divide] = useBetOperations(
    bet,
    false,
    userSettings.sound,
    handleNotification,
    toFix,
    minBet,
    maxBet,
    currency,
  );
  const [stopAnim, setStopAnim] = useState(false);

  const setStopAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 1000);
    }
  };
  // const [clearAnim, setclearAnim] = useState(false);
  // const [randAnim, setrandAnim] = useState(false);
  // const [playAinm, setplayAinm] = useState(false);
  const [halfAnim, sethalfAnim] = useState(false);
  const [multAnim, setmultAnim] = useState(false);
  const [autoAnim, setautoAnim] = useState(false);
  const [fast, setfast] = useState(false);

  const [playPress, setplayPress] = useState(false);
  const [playUnpress, setplayUnpress] = useState(false);

  const [setBetA, setSetBetA] = useState(false);
  const setAnimation = (a, b) => {
    if (a) {
      b(false);
      clearTimeout();
    } else {
      b(true);
      setTimeout(() => {
        b(false);
      }, 500);
    }
  };

  useEffect(() => {
    if (clickable) {
      setplayPress(false); // არ ვიცი აქ უნდა ეს თუ  58-ე ხაზზე
      setplayUnpress(true);
      setTimeout(() => {
        setplayUnpress(false);
      }, 200);
    }
  }, [clickable]);

  useEffect(() => {
    handleBetAmount(ubet);
  }, [ubet, handleBetAmount]);

  const [showRegular, setshowRegular] = useState(true);
  const [showStop, setshowStop] = useState(false);
  const [fadeInUpFloor, setfadeInUpFloor] = useState(false);
  const [fadeInDownFloor, setfadeInDownFloor] = useState(false);
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }
    if (isAutoOn) {
      setshowRegular(false);
      setshowStop(true);
    } else {
      setshowRegular(true);
      setfadeInUpFloor(true);
      setfadeInDownFloor(true);
      setTimeout(() => {
        setshowStop(false);
      }, 500);
    }
  }, [isAutoOn]);
  return (
    <FooterD clickable={clickable}>
      {showStop && (
        <StopFooter
          setStopAnimation={() => setStopAnimation(stopAnim, setStopAnim)}
          stopAnim={stopAnim}
          betTotal={betTotal}
          betCount={betCount}
          toggleIsAutoOn={toggleIsAutoOn}
          bet={ubet}
          fadeOut={showRegular}
          isFast={isFast}
          toFix={toFix}
          currency={currency}
        />
      )}
      {showRegular && (
        <Regular>
          <Floor fadeInUpFloor={fadeInUpFloor}>
            <Button
              isTurboOn={false}
              onClick={() => {
                sethalfAnim(true);
                setTimeout(() => {
                  sethalfAnim(false);
                  divide();
                }, 300);
              }}
              animOn={halfAnim}
            >
              <div className="white" />
              1/2
            </Button>
            <Bet
              setBetA={setBetA}
              onClick={() => {
                if (sound) forward();
                setAnimation(setBetA, setSetBetA);
                setTimeout(() => {
                  handleAbove("setBet" + ubet);
                  // handleAboveAnim(true);
                }, 100);
              }}
            >
              <span>
                {currencies[currency]}
                {ubet < minBet ? (+minBet.toFixed(toFix)) : ubet > maxBet ? (+maxBet.toFixed(toFix)) : (+ubet).toFixed(toFix)}
              </span>
            </Bet>
            <Button
              onClick={() => {
                setmultAnim(true);
                setTimeout(() => {
                  setmultAnim(false);
                  multiply(2);
                }, 300);
              }}
              animOn={multAnim}
              isTurboOn={false}
            >
              <div className="white" />
              2X
            </Button>
          </Floor>

          <Floor fadeInDownFloor={fadeInDownFloor}>
            <Button
              onClick={() => {
                setisTurboOn((isTurboOn) => {
                  if (sound && !isTurboOn) fastplaybtnSfx();
                  handleIsFast(!isTurboOn);
                  return !isTurboOn;
                });

                setfast(true);
                setTimeout(() => {
                  setfast(false);
                }, 300);
              }}
              isTurboOn={isTurboOn}
              animOn={fast}
            >
              <div className="white"></div>
              <FastSvg />
            </Button>
            <Play
              playPress={playPress}
              playUnpress={playUnpress}
              onClick={() => {
                if (betInfo.balance >= ubet) {
                  if (sound) playSfx();
                  setplayPress(true);
                  saveBetAndPlay(ubet);
                } else {
                  handleNotification("Not enough balance");
                }
              }}
              id="play"
            >
              PLAY
            </Play>
            <Button
              className="auto"
              onClick={() => {
                if (!clicked) {
                  setclicked(true);
                  if (sound) forward();
                  setautoAnim(true);
                  setTimeout(() => {
                    setclicked(false);
                    setautoAnim(false);
                    handleAbove("auto");
                  }, 200);
                }
              }}
              animOn={autoAnim}
              autoBtn={true}
              isTurboOn={false}
            >
              <div className="white" />

              <AutoSvg />
            </Button>
          </Floor>
        </Regular>
      )}
    </FooterD>
  );
}
